export default __webpack_public_path__ + "static/media/ReportingIcon.f741bec5.svg";